import useTable from "@organisms/Table/Table.context"
import ViewBar from "@organisms/ViewBar/ViewBar"

export default function TableKeywordSearch() {
    const { searchKeywords, setSearchKeywords } = useTable()

    return <ViewBar.SearchButton defaultValue={searchKeywords} onValueChange={setSearchKeywords} />
}
